var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"content"},[_c('span',[_vm._v(_vm._s(_vm.headerText))]),_c('span',[_c('img',{attrs:{"src":_vm.minLogo,"alt":""}}),_vm._v("  "+_vm._s(_vm.phone))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }